export default __webpack_public_path__ + "static/media/checkbox-disabled.762bdbda.svg";